import { render, staticRenderFns } from "./fireDetectionAlarmSystemTab.vue?vue&type=template&id=a2a9845c"
import script from "./fireDetectionAlarmSystemTab.vue?vue&type=script&lang=js"
export * from "./fireDetectionAlarmSystemTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a9845c')) {
      api.createRecord('a2a9845c', component.options)
    } else {
      api.reload('a2a9845c', component.options)
    }
    module.hot.accept("./fireDetectionAlarmSystemTab.vue?vue&type=template&id=a2a9845c", function () {
      api.rerender('a2a9845c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/fdas/fireDetectionAlarmSystemTab.vue"
export default component.exports